import * as React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip } from '@mui/material'

import { truncatedOptionLabel } from 'lib/Helper'
import { DEFAULT_CHAR_LIMIT } from 'lib/GlobalConstants'
import 'components/Shared/Chip/Chip.scss'

type ChipProps = {
  filterValues: string[]
  title?: string
  variant?: string
  size?: string
  extraProps?: any
  dataCy?: string
  sx?: Array<object> | object
}

const CustomChip = ({
  filterValues = [],
  title,
  variant,
  size,
  sx,
  dataCy = 'autocomplete-chip',
  extraProps = {},
}: ChipProps) => {
  const titleText = `${title}: `
  const filterLength = filterValues?.length
  const filterValuesCount = filterLength > 1 ? ` + ${filterLength - 1}` : ''

  const getTitleText = () => (title ? <strong>{titleText}</strong> : null)
  const ELLIPSIS_LENGTH = 3
  const chipLabelHandler = () => {
    return (
      <>
        {getTitleText()}
        {truncatedOptionLabel(
          filterValues[0],
          DEFAULT_CHAR_LIMIT + ELLIPSIS_LENGTH,
        )}
        {filterValuesCount}
      </>
    )
  }

  const chipProps = {
    label: chipLabelHandler(),
    size,
    variant,
    'data-cy': dataCy,
    sx,
    ...extraProps,
  }

  return filterValues[0]?.length > DEFAULT_CHAR_LIMIT + ELLIPSIS_LENGTH ||
    filterValuesCount ? (
    <Tooltip placement="bottom" title={<>{filterValues?.join(', ')}</>}>
      <Chip {...chipProps} />
    </Tooltip>
  ) : (
    <Chip {...chipProps} />
  )
}

export default CustomChip
